(function (scope, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!scope) return;
  scope.HyfenPride = api;
  function boot() {
    const root = scope.document.querySelector('[data-hyfen-pride-config]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.textContent);
    if (scope.hyfenPrideController) scope.hyfenPrideController.destroy();
    scope.hyfenPrideController = api.attach(scope, config);
  }
  if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  scope.document.addEventListener('shopify:section:load', boot);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  const EVENT = Object.freeze({
    request: 'customily-selected-options', response: 'customily-selected-options-ready',
    set: 'customily-set-option-value', changed: 'customily-options-changed'
  });
  const names = Object.freeze({
    first: 'First Country', second: 'Second Country', style: 'Choose your Style', mode: 'Identity Mode',
    templateMode: 'Template Mode', pride: 'Proud Tagline'
  });
  const normalize = value => String(value == null ? '' : value).normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');

  function resolvePlace(places, value) {
    const key = normalize(value);
    if (!key || /^\d+$/.test(key)) return null; // Customily option IDs are not Studio IDs.
    const aliases = { usa: 'US', unitedstatesofamerica: 'US', trkiye: 'TR', turkiye: 'TR', turkey: 'TR' };
    const matches = places.filter(place => normalize(place.country) === key || normalize(place.iso) === key || place.iso === aliases[key]);
    return matches.length === 1 ? matches[0] : null;
  }

  function derive(config, firstValue, secondValue) {
    const first = resolvePlace(config.places, firstValue), second = resolvePlace(config.places, secondValue);
    if (!first || !second) return { valid: false, mode: 'pending', message: '',
      incomplete: !normalize(firstValue) || !normalize(secondValue) };
    if (first.iso !== second.iso) return { valid: true, mode: 'dual', message: '' };
    const rule = config.pride[first.iso];
    if (!rule || !['approved', 'sourced'].includes(rule.status) || typeof rule.message !== 'string' ||
        !/^PROUD [A-Z][A-Z &'\u00c0-\u024f-]*$/i.test(rule.message) || rule.message.length > 64) {
      return { valid: false, mode: 'pending', message: '' };
    }
    return { valid: true, mode: 'single', message: rule.message };
  }

  function readSnapshot(options) {
    if (!Array.isArray(options)) return null;
    const modeFields = options.filter(option => normalize(option.name) === normalize(names.mode) && option.type === 'Text Input');
    if (!modeFields.length) return null;
    if (modeFields.length !== 1) throw new Error('Multiple Identity Mode fields');
    const mode = modeFields[0];
    const own = options.filter(option => String(option.setId) === String(mode.setId));
    function one(name, required) {
      const matches = own.filter(option => normalize(option.name) === normalize(name));
      if (matches.length > 1 || (required && matches.length !== 1)) throw new Error('Ambiguous or missing ' + name);
      return matches[0] || null;
    }
    const first = one(names.first, true), second = one(names.second, true), style = one(names.style, true);
    const templateMode = one(names.templateMode, true), pride = one(names.pride, false);
    function selected(option) {
      const details = option.valueDetails && option.valueDetails.details;
      return details && details.value ? details.value : option.value;
    }
    const ordinary = own.filter(option => normalize(option.name) === 'tagline' || normalize(option.name).startsWith('latintagline'));
    return {
      mode, templateMode, pride, ordinary, firstField: first, secondField: second, styleField: style,
      first: selected(first), second: selected(second), style: selected(style), template: selected(templateMode)
    };
  }

  function attach(win, config) {
    const listeners = [];
    let disposed = false, timer = null, timeout = null, revealTimer = null, inFlight = false;
    let revision = 0, requestedRevision = 0, attempts = 0, lastKey = '', active = false, readyKey = '', revealedOnce = false;

    const params = new URLSearchParams(win.location.search);
    const requestedFirst = String(params.get('hyfen_country_1') || params.get('@hyfen_country_1') || '').trim();
    const requestedSecond = String(params.get('hyfen_country_2') || params.get('@hyfen_country_2') || '').trim();
    const requestedStyle = String(params.get('hyfen_style') || params.get('@hyfen_style') || '').trim();
    const hasHandoff = Boolean(requestedFirst || requestedSecond || requestedStyle);
    const requestedTaglineMode = ['edit', 'remove'].includes(params.get('hyfen_tagline_mode')) ? params.get('hyfen_tagline_mode') : 'keep';
    const requestedTaglineText = String(params.get('hyfen_tagline_text') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, 40);
    const requestedFinalMessage = String(params.get('hyfen_final_message') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, 64);
    let state = { phase: 'inactive', mode: null };
    const status = win.document.querySelector('[data-hyfen-pride-status]');
    function listen(target, event, callback, capture) {
      target.addEventListener(event, callback, capture);
      listeners.push(() => target.removeEventListener(event, callback, capture));
    }
    function report(phase, mode) {
      state = { phase, mode: mode || null };
      if (status) {
        status.hidden = phase !== 'error';
        status.textContent = phase === 'error' ? 'Your design could not finish updating. Please refresh the page and try again.' : '';
      }
    }
    // Shopify/Horizon owns variant synchronization. The previous timer/MutationObserver
    // workaround could race Customily initialization and has intentionally been removed.
    function syncVariant() {}
    function keepVariantSynced() {}
    function schedule() {
      if (disposed) return;
      if (timer) win.clearTimeout(timer);
      timer = win.setTimeout(request, 30);
    }
    function request() {
      timer = null;
      if (disposed || inFlight) return;
      syncVariant();
      inFlight = true; requestedRevision = revision;
      timeout = win.setTimeout(() => {
        inFlight = false;
        if (active) report('error', state.mode);
      }, 2000);
      win.dispatchEvent(new win.CustomEvent(EVENT.request));
    }
    function setValue(field, value) {
      win.dispatchEvent(new win.CustomEvent(EVENT.set, { detail: {
        setId: field.setId, optionId: field.id, optionValue: value
      } }));
    }
    function samePlace(current, requested) {
      if (!requested) return true;
      const a = resolvePlace(config.places, current), b = resolvePlace(config.places, requested);
      return a && b ? a.iso === b.iso : normalize(current) === normalize(requested);
    }
    function sameStyle(current, requested) {
      return !requested || normalize(current) === normalize(requested);
    }
    function coverPreview() {
      if (!hasHandoff) return;
      win.clearTimeout(revealTimer);
      win.document.documentElement.classList.add('hyfen-customily-initializing');
      win.document.documentElement.classList.remove('hyfen-customily-ready');
    }
    function releasePreview() {
      if (!hasHandoff || disposed) return;
      win.document.documentElement.classList.remove('hyfen-customily-initializing');
      win.document.documentElement.classList.add('hyfen-customily-ready');
      revealedOnce = true;
    }
    function revealWhenStable(key) {
      if (!hasHandoff) return;
      if (readyKey !== key) {
        readyKey = key;
        win.clearTimeout(revealTimer);
        revealTimer = win.setTimeout(function () {
          if (disposed || readyKey !== key || state.phase !== 'ready') return;
          releasePreview();
        }, 650);
      }
    }

    // Customily can expose the visible country/style selects before its hidden
    // helper fields finish synchronizing. The customer-facing preview should be
    // released from the loader as soon as the three visible requested values are
    // actually present and stable; hidden mode/tagline work may continue behind it.
    function fieldLabel(control) {
      if (!control) return '';
      const id = control.id;
      if (id) {
        const direct = win.document.querySelector('label[for="' + CSS.escape(id) + '"]');
        if (direct) return direct.textContent || '';
      }
      let node = control.parentElement;
      for (let i = 0; node && i < 4; i++, node = node.parentElement) {
        const label = node.querySelector && node.querySelector('label');
        if (label) return label.textContent || '';
      }
      return '';
    }

    function hideDesignControl(control) {
      if (!control || control.dataset.hyfenDesignLocked === 'true') return;
      control.dataset.hyfenDesignLocked = 'true';
      control.setAttribute('aria-hidden', 'true');
      control.style.setProperty('display', 'none', 'important');
      const id = control.id;
      let label = id ? win.document.querySelector('label[for="' + CSS.escape(id) + '"]') : null;
      if (!label) {
        let node = control.parentElement;
        for (let i = 0; node && i < 3 && !label; i++, node = node.parentElement) {
          label = node.querySelector && node.querySelector('label');
        }
      }
      if (label) {
        label.dataset.hyfenDesignLocked = 'true';
        label.style.setProperty('display', 'none', 'important');
      }
      const parent = control.parentElement;
      if (parent && label && parent.contains(label)) {
        const interactive = parent.querySelectorAll('select,input,textarea,button,[role="combobox"]');
        if (interactive.length === 1) parent.style.setProperty('display', 'none', 'important');
      }
    }
    function lockVisibleDesignControls() {
      if (!hasHandoff) return;
      const controls = Array.from(win.document.querySelectorAll('select, [role="combobox"]'));
      controls.forEach(control => {
        const label = normalize(fieldLabel(control));
        if (label.includes('firstcountry') || label.includes('secondcountry') || label.includes('chooseyourstyle') || label === 'style') {
          hideDesignControl(control);
        }
      });
    }
    function makeHandoffUrl(pathname) {
      const url = new URL(win.location.href);
      url.pathname = pathname;
      url.searchParams.delete('variant');
      url.searchParams.delete('hyfen_quantity');
      return url;
    }
    function makeStudioEditUrl() {
      const url = new URL('/', win.location.origin);
      url.searchParams.set('hyfen_country_1', requestedFirst);
      url.searchParams.set('hyfen_country_2', requestedSecond);
      url.searchParams.set('hyfen_style', requestedStyle);
      url.searchParams.set('hyfen_tagline_mode', requestedTaglineMode);
      if (requestedTaglineMode === 'edit' && requestedTaglineText) url.searchParams.set('hyfen_tagline_text', requestedTaglineText);
      url.searchParams.set('step', 'studio');
      const previewTheme = params.get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      return url.pathname + url.search.replace(/\+/g, '%20');
    }
    function ensureOrderMessageProperty() {
      if (!hasHandoff) return;
      const button = win.document.getElementById('customily-cart-btn');
      const form = button && button.form;
      if (!form) return;
      let input = form.querySelector('input[data-hyfen-message-property]');
      if (!input) {
        input = win.document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Message]';
        input.dataset.hyfenMessageProperty = 'true';
        form.appendChild(input);
      }
      const orderMessage = requestedTaglineMode === 'remove' ? 'No message' : (requestedFinalMessage || requestedTaglineText || '');
      input.value = orderMessage;
      if (form.dataset.hyfenMessageFormdata !== 'true') {
        form.dataset.hyfenMessageFormdata = 'true';
        form.addEventListener('formdata', function (event) {
          const value = requestedTaglineMode === 'remove' ? 'No message' : (requestedFinalMessage || requestedTaglineText || '');
          event.formData.set('properties[Message]', value);
        });
      }
    }
    function ensureDesignSummary() {
      if (!hasHandoff || win.document.querySelector('[data-hyfen-design-summary]')) return;
      const button = win.document.getElementById('customily-cart-btn');
      const form = button && button.form;
      if (!form) return;
      const summary = win.document.createElement('section');
      summary.dataset.hyfenDesignSummary = 'true';
      summary.className = 'hyfen-design-summary';
      const message = requestedTaglineMode === 'remove' ? 'No message' : (requestedFinalMessage || requestedTaglineText || 'HYFEN suggested message');
      const currentHandle = win.location.pathname.split('/').filter(Boolean).pop();
      const tee = makeHandoffUrl('/products/the-hyfen-t-shirt');
      const hoodie = makeHandoffUrl('/products/the-hyfen-hoodie');
      summary.innerHTML = '<div class="hyfen-design-summary__head"><div><span class="hyfen-design-summary__eyebrow">YOUR HYFEN</span><strong>' +
        escapeHtml(requestedFirst + ' × ' + requestedSecond) + '</strong></div><a class="hyfen-design-summary__edit" href="' + escapeHtml(makeStudioEditUrl()) + '">Edit Design</a></div>' +
        '<dl><div><dt>Style</dt><dd>' + escapeHtml(requestedStyle) + '</dd></div><div><dt>Message</dt><dd>' + escapeHtml(message) + '</dd></div></dl>' +
        '<div class="hyfen-product-switch" aria-label="Choose product"><span>Print it on</span><a ' + (currentHandle === 'the-hyfen-t-shirt' ? 'aria-current="page" ' : '') + 'href="' + escapeHtml(tee.pathname + tee.search.replace(/\+/g, '%20')) + '">T-shirt</a><a ' + (currentHandle === 'the-hyfen-hoodie' ? 'aria-current="page" ' : '') + 'href="' + escapeHtml(hoodie.pathname + hoodie.search.replace(/\+/g, '%20')) + '">Hoodie</a></div>';
      form.insertBefore(summary, form.firstChild);
    }
    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    }
    function refreshLockedProductUI() {
      lockVisibleDesignControls();
      ensureDesignSummary();
      ensureOrderMessageProperty();
    }
    function visibleHandoffState() {
      const controls = Array.from(win.document.querySelectorAll('select, [role="combobox"]'));
      const found = { first: '', second: '', style: '' };
      controls.forEach(control => {
        const label = normalize(fieldLabel(control));
        let value = '';
        if (control.tagName === 'SELECT') {
          const option = control.options && control.options[control.selectedIndex];
          value = option ? option.textContent : control.value;
        } else {
          value = control.value || control.getAttribute('aria-valuetext') || control.textContent || '';
        }
        if (!found.first && label.includes('firstcountry')) found.first = String(value || '').trim();
        else if (!found.second && label.includes('secondcountry')) found.second = String(value || '').trim();
        else if (!found.style && (label.includes('chooseyourstyle') || label === 'style')) found.style = String(value || '').trim();
      });
      return found;
    }
    function visibleHandoffMatches() {
      const visible = visibleHandoffState();
      return samePlace(visible.first, requestedFirst) && samePlace(visible.second, requestedSecond) &&
        sameStyle(visible.style, requestedStyle) && Boolean(visible.first && visible.second && visible.style);
    }
    function scheduleVisibleRelease(forceReset) {
      if (!hasHandoff || revealedOnce || disposed || !visibleHandoffMatches()) return;
      const key = JSON.stringify(['visible', requestedFirst, requestedSecond, requestedStyle]);
      if (readyKey === key && !forceReset) return;
      readyKey = key;
      win.clearTimeout(revealTimer);
      revealTimer = win.setTimeout(function () {
        if (!disposed && visibleHandoffMatches()) releasePreview();
      }, 900);
    }
    // The product gallery also has a 3-second first-paint safety release in
    // theme.liquid. This bridge may reveal earlier, but it can no longer trap
    // the customer behind the loading cover if Customily's event API is late
    // or unavailable.
    function receive(event) {
      if (!inFlight || disposed) return;
      inFlight = false; win.clearTimeout(timeout);
      if (requestedRevision !== revision) { schedule(); return; }
      let snapshot;
      try { snapshot = readSnapshot(event.detail && event.detail.options); }
      catch (_) { active = true; report('error'); return; }
      if (!snapshot) { active = false; report('inactive'); return; }
      active = true;
      refreshLockedProductUI();

      // A Studio handoff is authoritative. Apply country/style first so Customily
      // never settles on library option 1 (Afghanistan) before the requested design.
      const firstMatches = samePlace(snapshot.first, requestedFirst);
      const secondMatches = samePlace(snapshot.second, requestedSecond);
      const styleMatches = sameStyle(snapshot.style, requestedStyle);
      if (firstMatches && secondMatches && styleMatches) scheduleVisibleRelease();
      const handoffKey = JSON.stringify([requestedFirst, requestedSecond, requestedStyle, snapshot.first, snapshot.second, snapshot.style]);
      if (handoffKey !== lastKey && hasHandoff) { lastKey = handoffKey; attempts = 0; }
      if (hasHandoff && (!firstMatches || !secondMatches || !styleMatches)) {
        if (++attempts > 12) { report('error', 'pending'); return; }
        report('syncing', 'pending');
        if (!firstMatches && requestedFirst) setValue(snapshot.firstField, requestedFirst);
        else if (!secondMatches && requestedSecond) setValue(snapshot.secondField, requestedSecond);
        else if (!styleMatches && requestedStyle) setValue(snapshot.styleField, requestedStyle);
        schedule();
        return;
      }

      const desired = derive(config, snapshot.first, snapshot.second);
      if (!desired.valid) { report(desired.incomplete ? 'waiting' : 'error', 'pending'); return; }
      const taglineFields = desired.mode === 'single' ? (snapshot.pride ? [snapshot.pride] : []) : snapshot.ordinary;
      // Keep deliberately leaves dual-country wording to the proven Customily V3
      // conditions (including Spanish pair/style rules). Edit/Remove override every
      // possible dual tagline field so the active conditional field cannot be missed.
      const requestedMessage = requestedTaglineMode === 'remove' ? '' : requestedTaglineMode === 'edit' ? requestedTaglineText : desired.mode === 'single' ? desired.message : null;
      const taglineMatches = requestedMessage === null || (taglineFields.length && taglineFields.every(field => String(field.value || '') === requestedMessage));
      const key = JSON.stringify([snapshot.first, snapshot.second, snapshot.style, desired.mode, desired.message, requestedTaglineMode, requestedTaglineText]);
      if (key !== lastKey) { lastKey = key; attempts = 0; }
      const templateMatches = snapshot.template === desired.mode;
      const modeMatches = snapshot.mode.value === desired.mode;
      const prideMatches = desired.mode === 'dual' ? !snapshot.pride : !!snapshot.pride;
      if (templateMatches && modeMatches && prideMatches && taglineMatches) {
        if ((desired.mode === 'single' && snapshot.ordinary.length) ||
            (desired.mode === 'dual' && !snapshot.ordinary.length)) {
          report('error', desired.mode); return;
        }
        report('ready', desired.mode);
        revealWhenStable(key);
        return;
      }
      if (++attempts > 12) { report('error', desired.mode); return; }
      report('syncing', desired.mode);
      if (!templateMatches) setValue(snapshot.templateMode, desired.mode);
      else if (!modeMatches) setValue(snapshot.mode, desired.mode);
      else if (!taglineMatches) {
        const pending = taglineFields.filter(field => String(field.value || '') !== requestedMessage);
        if (pending.length) pending.forEach(field => setValue(field, requestedMessage));
        else { report('error', desired.mode); return; }
      } else { report('error', desired.mode); return; }
      schedule();
    }
    function externalChange(event) {
      const option = event.detail && event.detail.option;
      const label = option && (option.label || option.name);
      if (label && [names.templateMode, names.mode, names.pride]
        .some(name => normalize(name) === normalize(label))) return;
      revision++; attempts = 0; readyKey = '';
      coverPreview();
      syncVariant();
      if (active) report('syncing', state.mode);
      schedule();
    }

    // Customily emits preview/load lifecycle events while it is still rendering.
    // They are notifications, not user edits. Treating them as revisions can
    // invalidate every in-flight snapshot and trap the page behind the loader.
    // During the first handoff they simply restart the quiet-period timer; after
    // the first successful reveal we re-check silently without hiding the design.
    function lifecycleChange() {
      if (disposed) return;
      attempts = 0;
      if (!revealedOnce) {
        if (visibleHandoffMatches()) scheduleVisibleRelease(true);
        else coverPreview();
      }
      refreshLockedProductUI();
      schedule();
    }

    listen(win, EVENT.response, receive);
    listen(win, EVENT.changed, externalChange);
    for (const event of ['customily-options-loaded', 'customily-preview-load-finished',
      'customily-load-customization-finished', 'customily-variation-change-finished', 'pageshow']) {
      listen(win, event, lifecycleChange);
    }

    let visiblePoll = null;
    if (hasHandoff) {
      visiblePoll = win.setInterval(function () {
        if (disposed) {
          if (visiblePoll) { win.clearInterval(visiblePoll); visiblePoll = null; }
          return;
        }
        refreshLockedProductUI();
        if (!revealedOnce && visibleHandoffMatches()) scheduleVisibleRelease();
        if (revealedOnce && win.document.querySelector('[data-hyfen-design-summary]') && win.document.querySelector('input[data-hyfen-message-property]')) {
          win.clearInterval(visiblePoll); visiblePoll = null;
        }
      }, 150);
    }
    // Respect Customily's own add-to-cart path; only stop stale/incomplete identity output.
    function guard(event) {
      ensureOrderMessageProperty();
      if (!active || state.phase === 'ready' || !event.target || !event.target.closest) return;
      const cartButton = win.document.getElementById('customily-cart-btn');
      const isCart = event.type === 'submit' ? cartButton && cartButton.form === event.target :
        event.target.closest('#customily-cart-btn');
      if (!isCart) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (status) {
        status.hidden = false;
        status.textContent = state.phase === 'waiting' ? 'Choose both countries to continue.' : state.phase === 'error' ?
          'Your design could not finish updating. Please refresh the page and try again.' :
          'Your design is updating. Please try again in a moment.';
      }
    }
    listen(win.document, 'click', guard, true);
    listen(win.document, 'submit', guard, true);
    keepVariantSynced();
    refreshLockedProductUI();
    schedule();
    return {
      refresh: externalChange.bind(null, {}),
      getState: () => Object.assign({}, state),
      destroy: () => {
        disposed = true; win.clearTimeout(timer); win.clearTimeout(timeout); win.clearTimeout(revealTimer);
        if (visiblePoll) win.clearInterval(visiblePoll);
        listeners.forEach(remove => remove());
        if (status) { status.hidden = true; status.textContent = ''; }
      }
    };
  }
  return Object.freeze({ EVENT, names, normalize, resolvePlace, derive, readSnapshot, attach });
});
